import {Component, OnInit, ViewChild} from '@angular/core';
import {EnterpriseService} from '../../../services/enterprise.service';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {ITdoTableItemModel} from '../../../tdo-controls/common/tdo-table/interfaces/i-tdo-table-item.model';
import {TdoTableActionsEnum, TdoTableModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {TdoUserGroupConfigurationModel} from '../../../models/configuration/user/tdo-user-group-configuration.model';
import {MatTableDataSource} from '@angular/material/table';
import {DialogService} from '../../../services/dialog.service';
import {TdoTableEvent} from '../../../tdo-controls/common/tdo-table/models/tdo-table.event';
import {UserService} from '../../../services/user.service';
import {Globals} from '../../../globals';
import {StaticDataService} from '../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {TdoUserRoleConfigurationModel} from '../../../models/configuration/user/tdo-user-role-configuration.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {TdoUserGroupRoleConfigurationModel} from '../../../models/configuration/user/tdo-user-group-role-configuration.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SignalrService} from '../../../services/socket/signalr.service';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {ConfigurationService} from '../configuration.service';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';

@Component({
  selector: 'app-user-groups',
  templateUrl: './user-groups.component.html',
  styleUrls: ['./user-groups.component.scss']
})
export class UserGroupsComponent implements OnInit {
  @ViewChild('groupTable') groupTable: TdoTableV2Component;

  clientList: TdoClientConfigurationModel[];
  selectedClient: TdoClientConfigurationModel;

  selectedGroup: TdoUserGroupConfigurationModel;
  groups: TdoUserGroupConfigurationModel[];
  editedGroups: TdoUserGroupConfigurationModel[] = [];
  isLoading = true;
  userGroupTypeEnums: EnumValidValueItemModel[];
  userRoles: TdoUserRoleConfigurationModel[];

  constructor(private enterpriseService: EnterpriseService,
              private userService: UserService,
              private globals: Globals,
              private staticDataService: StaticDataService,
              private snackbar: MatSnackBar,
              private signalrService: SignalrService,
              public configurationService: ConfigurationService,
              private dialogService: DialogService) { }

  ngOnInit(): void {
    if (this.staticDataService.isReady) {
      this.onStaticDataReady();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.onStaticDataReady();
        }
      });
    }
  }

  onStaticDataReady() {
    this.userGroupTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumUserGroupType');

    this.enterpriseService.getClients().subscribe((res) => {
      this.clientList = res;
      if (this.clientList.length > 0) {
        const currentClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
        if (currentClient) {
          this.selectedClient = currentClient;
        } else {
          this.selectedClient = this.clientList[0];
        }
      }

      this.userService.getUserRoles().subscribe((res0) => {
        this.userRoles = res0;
      });

      this.userService.getUserGroups(this.selectedClient.TDOCID).subscribe((res1) => {
        this.groups = res1;
        this.isLoading = false;
        // this.refreshTableData();
        if (this.groups.length > 0) {
          this.selectedGroup = this.groups[0];
          setTimeout(() => {
            this.groupTable.selectionControl.select(this.groups[0]);
          }, 100);
        }
      });
    });
  }

  onChangeClient(e) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeClient(e);
          return;
        } else {
          this.groupTable.selectionControl.select(this.selectedGroup);
        }
      });
    } else {
      this.changeClient(e);
    }
  }

  changeClient(client: TdoClientConfigurationModel) {
    this.selectedClient = client;
    this.userService.getUserGroups(this.selectedClient.TDOCID).subscribe((res1) => {
      this.selectedGroup = null;
      this.groups = res1;
      this.isLoading = false;
      this.groupTable.updateData(this.groups);

      if (this.groups.length > 0) {
        this.selectedGroup = this.groups[0];
        setTimeout(() => {
          this.groupTable.selectionControl.select(this.groups[0]);
        }, 100);
      }
    });
  }

  /*refreshTableData() {
    this.tableViewData = Array.from(this.groups, (_) => {
      const model = new TableViewData();
      model.UserGroupName = _.UserGroupName;
      model.model = _;
      return model;
    });

    if (!this.tableModel) {
      this.dataSource = new MatTableDataSource<ITdoTableItemModel>(this.tableViewData);
      if (this.dataSource.data === null || this.dataSource.data === undefined) {
        this.dataSource.data = this.tableViewData;
      }
      this.tableModel = new TdoTableModel (this.displayedColumns, this.displayedColumnsLabels, this.dataSource, '', 'asc');
      this.tableModel.searchPredicate = (data: TableViewData, filter: string) => {
        if (data.UserGroupName.toLowerCase().includes(filter)) {
          return true;
        }
      };
    } else {
      this.dataSource.data = this.tableViewData;
      this.dataSource._updateChangeSubscription();
    }
  }*/

  deleteUserGroup(model: TdoUserGroupConfigurationModel) {
    this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.UserGroupName}?`).subscribe((result) => {
      if (result === true) {
        this.userService.deleteUserGroup(model.UserGroupId).subscribe((res) => {
          const idx = this.groups.findIndex(p => p.UserGroupId === model.UserGroupId);
          if (idx > -1) {
            this.groups.splice(idx, 1);
            if (this.groups.length > 0) {
              this.selectedGroup = this.groups[0];
            }
            this.groupTable.updateData(this.groups);
          }
        });
      } else {
        //
      }
    });
  }

  onTdoTableItemClick(event: TdoTableEvent) {
    const model = event.value['model'] as TdoUserGroupConfigurationModel;
    this.selectedGroup = model;
  }

  onNew(event: any) {
    this.configurationService.setDirty();
    const group = new TdoUserGroupConfigurationModel();
    group.UserGroupName = 'New Group';
    group.TDOCID = this.selectedClient.TDOCID;
    group.cfgTDOUserGroupRoles = [];
    this.groups.unshift(group);
    this.selectedGroup = group;
    this.groupTable.updateData(this.groups);
    this.groupTable.selectionControl.select(this.selectedGroup);
  }

  onSave(event: any) {
    this.isLoading = true;
    this.userService.saveUserGroups(this.editedGroups).subscribe((res) => {
      this.configurationService.setClean();
      this.editedGroups = [];
      for (const model of res) {
        const mIdx = this.groups.findIndex(p => p.UserGroupId === model.UserGroupId);
        if (mIdx > -1) {
          this.groups[mIdx] = model;
        }
      }
      this.signalrService.messageAllUsers(MessagingConstants.USER_ROLES_CHANGED, null);
      this.isLoading = false;
      this.snackbar.open('Save success', '', {duration: 5000});
      // Fold edited back in
    });
  }

  onModelChange(event: any) {
    this.selectedGroup.UserGroupName = event;
    if (!this.editedGroups.includes(this.selectedGroup)) {
      this.editedGroups.push(this.selectedGroup);
    }

    /*this.refreshTableData();
    const row = this.dataSource.data.find(p => (p as TableViewData).model === this.selectedGroup);
    this.groupTable.selection.select(row);*/
  }

  onUserGroupChange(event: string) {
    this.configurationService.setDirty();
    this.selectedGroup.enumUserGroupTypeID = event;

    if (!this.editedGroups.includes(this.selectedGroup)) {
      this.editedGroups.push(this.selectedGroup);
    }
  }

  onRoleChange(event: MatCheckboxChange, role: TdoUserRoleConfigurationModel) {
    this.configurationService.setDirty();
    const userGroupRole = this.selectedGroup.cfgTDOUserGroupRoles.find(p => p.RoleId === role.RoleId);
    const userGroupRoleIdx = this.selectedGroup.cfgTDOUserGroupRoles.findIndex(p => p.RoleId === role.RoleId);

    if (event.checked) {
      if (userGroupRole) {
        this.selectedGroup.cfgTDOUserGroupRoles[userGroupRoleIdx].xauditDeleted = false;
      } else {
        const model = new TdoUserGroupRoleConfigurationModel();
        model.RoleId = role.RoleId;
        this.selectedGroup.cfgTDOUserGroupRoles.push(model);
      }
    } else {
      if (userGroupRole) {
        userGroupRole.xauditDeleted = true;
      }
    }

    if (!this.editedGroups.includes(this.selectedGroup)) {
      this.editedGroups.push(this.selectedGroup);
    }
  }

  isChecked(role: TdoUserRoleConfigurationModel) {
    const roleGroup = this.selectedGroup.cfgTDOUserGroupRoles.find(p => p.RoleId === role.RoleId);
    if (roleGroup) {
      return true;
    } else {
      return false;
    }
  }

  onGroupSelection(event: TdoTableSelectionEvent) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.selectGroup(event.model);
          return;
        } else {
          this.groupTable.selectionControl.select(this.selectedGroup);
        }
      });
    } else {
      this.selectGroup(event.model);
    }
  }

  selectGroup(group: TdoUserGroupConfigurationModel) {
    this.selectedGroup = group;
  }
}
